import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import { GetLatestOpenTicketsForJobsRequest } from '@taxfyle/api-internal/internal/ticket_pb';
import { getFeatureToggleClient } from '../misc/featureToggles';
import { timestampToISO } from 'utils/grpcUtil';
import { JobTicketApi } from './API';
import DataLoader from 'dataloader';
import { JobTicket } from './JobTicket';
var JobTicketStore = /*#__PURE__*/function (_Store) {
  function JobTicketStore() {
    var _this;
    _classCallCheck(this, JobTicketStore);
    _this = _callSuper(this, JobTicketStore, arguments);
    _this.ticketsLoader = new DataLoader(_this._fetchLatestOpenTicketsForJobs.bind(_this), {
      cache: true,
      batch: true
    });
    _this.tickets = _this.collection({
      model: JobTicket,
      getDataId: function getDataId(attrs) {
        return "".concat(attrs.jobId, "/").concat(attrs.id);
      },
      getModelId: function getModelId(model) {
        return "".concat(model.job_id, "/").concat(model.id);
      }
    });
    _this.api = new JobTicketApi({
      baseURL: env.WORK_DOTNET_API,
      token$: _this.rootStore.authStore.token$
    }, _this.rootStore.workRealtime$);
    _this.getLatestTicketForJob = _this.getLatestTicketForJob.bind(_this);
    _this.fetchLatestOpenTicketsForJobs = _this.fetchLatestOpenTicketsForJobs.bind(_this);
    return _this;
  }
  _inherits(JobTicketStore, _Store);
  return _createClass(JobTicketStore, [{
    key: "getLatestTicketForJob",
    value: function getLatestTicketForJob(jobId) {
      var _this$tickets$find;
      return (_this$tickets$find = this.tickets.find(function (t) {
        return t.jobId === jobId;
      })) !== null && _this$tickets$find !== void 0 ? _this$tickets$find : null;
    }
  }, {
    key: "fetchLatestOpenTicketsForJobs",
    value: function () {
      var _fetchLatestOpenTicketsForJobs2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(jobIds) {
        var _this2 = this;
        var tickets;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (getFeatureToggleClient().variation('CustomerPortal.Tickets', false)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", []);
            case 2:
              if (!(jobIds.length === 0)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", []);
            case 4:
              _context.next = 6;
              return Promise.all(jobIds.map(function (id) {
                return _this2.ticketsLoader.load(id);
              }));
            case 6:
              tickets = _context.sent;
              return _context.abrupt("return", tickets);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fetchLatestOpenTicketsForJobs(_x) {
        return _fetchLatestOpenTicketsForJobs2.apply(this, arguments);
      }
      return fetchLatestOpenTicketsForJobs;
    }()
  }, {
    key: "_fetchLatestOpenTicketsForJobs",
    value: function () {
      var _fetchLatestOpenTicketsForJobs3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jobIds) {
        var _this3 = this;
        var response, responseMap, mapped;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.api.getLatestOpenTicketsForJobs(new GetLatestOpenTicketsForJobsRequest().setJobIdsList(jobIds));
            case 2:
              response = _context2.sent;
              responseMap = response.getLatestOpenTicketsMap();
              mapped = Array.from(responseMap.entries()).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  jobId = _ref2[0],
                  latestOpenTicket = _ref2[1];
                return _this3.mapToProps(jobId, latestOpenTicket);
              });
              this.tickets.set(mapped);
              return _context2.abrupt("return", jobIds.map(this.getLatestTicketForJob));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _fetchLatestOpenTicketsForJobs(_x2) {
        return _fetchLatestOpenTicketsForJobs3.apply(this, arguments);
      }
      return _fetchLatestOpenTicketsForJobs;
    }()
  }, {
    key: "mapToProps",
    value: function mapToProps(jobId, latestOpenTicketDto) {
      var _latestOpenTicketDto$, _latestOpenTicketDto$2;
      return {
        id: latestOpenTicketDto.getId(),
        jobId: jobId,
        dateUpdated: timestampToISO(latestOpenTicketDto.getUpdateTime()),
        statusMessage: (_latestOpenTicketDto$ = (_latestOpenTicketDto$2 = latestOpenTicketDto.getStatusMessage()) === null || _latestOpenTicketDto$2 === void 0 ? void 0 : _latestOpenTicketDto$2.getValue()) !== null && _latestOpenTicketDto$ !== void 0 ? _latestOpenTicketDto$ : ''
      };
    }
  }]);
}(Store);
export { JobTicketStore as default };
//# sourceMappingURL=JobTicketStore.js.map
